module.exports = __webpack_public_path__ + "img/pic28_2.4fd8326f.png";